import config from 'constants/config'
import { destinationsMap } from 'constants/experience'
import { getSearchItemDestinationId } from 'lib/search/searchItem'

const EXPERIENCE_DESTINATION_ALIASES: Record<string, string> = {
  'city of perth': 'perth',
  'melbourne city': 'melbourne',
  'city of melbourne': 'melbourne',
  'council of the city of sydney': 'sydney',
  'city of sydney': 'sydney',
}

const EXPERIENCE_DESTINATION_SECONDARY_TEXT: Record<string, string> = {
  'gold coast': 'City · Queensland, Australia',
  melbourne: 'City · Victoria, Australia',
  perth: 'City · Western Australia, Australia',
  sydney: 'City · New South Wales, Australia',
}

function normaliseDestinationName(value: string) {
  return value.trim().toLowerCase().replace(/\s+/g, ' ')
}

export function getCanonicalExperienceDestination(searchPhrase: string): App.SearchDestination | undefined {
  const normalisedSearchPhrase = normaliseDestinationName(searchPhrase)
  const canonicalName = EXPERIENCE_DESTINATION_ALIASES[normalisedSearchPhrase] ?? normalisedSearchPhrase

  if (!(canonicalName in EXPERIENCE_DESTINATION_SECONDARY_TEXT)) return undefined

  const place = destinationsMap(config.BRAND).find(destination => normaliseDestinationName(destination.name) === canonicalName)

  if (!place) return undefined

  return {
    searchType: 'destination',
    value: place.id,
    format: {
      mainText: place.name,
      secondaryText: EXPERIENCE_DESTINATION_SECONDARY_TEXT[canonicalName],
    },
  }
}

export function prependCanonicalExperienceDestination(
  searchResults: Array<App.SearchItem>,
  searchPhrase: string,
  vertical?: App.SearchPlaceVertical,
) {
  if (vertical !== 'experience' || searchPhrase.length < 2) return searchResults

  const canonicalDestination = getCanonicalExperienceDestination(searchPhrase)
  if (!canonicalDestination) return searchResults

  const matchingIndex = searchResults.findIndex(item => getSearchItemDestinationId(item) === canonicalDestination.value)
  if (matchingIndex >= 0) {
    const matchingItem = searchResults[matchingIndex]
    return [matchingItem, ...searchResults.filter((_, index) => index !== matchingIndex)]
  }

  return [canonicalDestination, ...searchResults]
}
